import writeXlsxFile from 'write-excel-file'
import {CircularProgress, Dialog, DialogContent} from "@mui/material";
import {useEffect, useState} from "react";
import {TradeInExportFragment, TradeInExportItemItemFragment, useExportTradeInItemsQuery} from "../../Queries";

type ExportLine = {
   itemNr: number
   item: TradeInExportItemItemFragment
   tradeIn: TradeInExportFragment
}

const numberFormat = "#,##0.00"

export const ItemExportToExcel = async (language: string, currency: string, data: ExportLine[]) => {
   // @ts-ignore
   const schema: any = [{
      column: "ID",
      type: String,
      value: (object: ExportLine) => object.item._id
   }, {
      column: "TRADEINID",
      type: String,
      value: (object: ExportLine) => object.tradeIn._id
   }, {
      column: "ITEMTYPE",
      type: String,
      value: (object: ExportLine) => object.item.wholeSale ? 'Wholesale' : 'Retail'
   }, {
      column: "ITEMSKU",
      type: String,
      value: (object: ExportLine) => object.item?.brandItem?.resolved?.originalSku || object.item.stockItem?.resolved?.sku
   }, {
      column: "ITEMNAME",
      type: String,
      value: (object: ExportLine) => object.item?.brandItem?.resolved?.nameLocalized?.[0]?.value || object.item.stockItem?.resolved?.title || object.item.wholeSale?.name
   }, {
      column: "ITEMVALUE",
      type: Number,
      format: numberFormat,
      value: (object: ExportLine) => object.item.wholeSale?.value || object.item.value || 0
   }, {
      column: "ITEMSIZE",
      type: String,
      value: (object: ExportLine) => object.item?.brandItem?.resolved?.sizeLocalized?.[0]?.value || object.item.stockItem?.resolved?.size
   }, {
      column: "ITEMIMAGE",
      type: String,
      value: (object: ExportLine) => object.item.imageUrls?.[0]
   }, {
      column: "ITEMCONDITION",
      type: Number,
      format: numberFormat,
      value: (object: ExportLine) => object.item.condition || object.item.brandItem?.condition
   }, {
      column: "ITEMSOLD",
      type: Boolean,
      value: (object: ExportLine) => object.item.stockItem?.isSold || object.item.brandItem?.isSold || false
   }, {
      column: "ITEMSELLPRICE",
      type: Number,
      format: numberFormat,
      value: (object: ExportLine) => object.item.brandItem?.resolved?.orderline?.discountedPrice || object.item.stockItem?.orderline?.discountedPrice
   }, {
      column: "ITEMSTATUS",
      type: String,
      value: (object: ExportLine) => object.item.rejected || 'ACCEPTED'
   }, {
      column: "TRADEINNR",
      type: Number,
      format: numberFormat,
      value: (object: ExportLine) => object.tradeIn.tradeInNr
   }, {
      column: "RECEIVED",
      type: Boolean,
      value: (object: ExportLine) => object.tradeIn.registered || false
   }, {
      column: "TRADEINDATE",
      type: Date,
      format: "YYYY-MM-DD",
      value: (object: ExportLine) => new Date(object.tradeIn.dateTime)
   }, {
      column: "PACKAGESTATUS",
      type: String,
      value: (object: ExportLine) => object.tradeIn.label?.deliveryStatus || 'Unknown'
   }, {
      column: "PACKAGEQR",
      type: String,
      value: (object: ExportLine) => object.tradeIn.label?.qrUrl || ''
   }, {
      column: "BONUS",
      type: Number,
      format: numberFormat,
      value: (object: ExportLine) => object.item?.bonus || ''
   }, {
      column: "SHOP",
      type: String,
      value: (object: ExportLine) => object.tradeIn.shop?.name || 'Unknown shop'
   }];

   await writeXlsxFile(data, {
      schema,
      fileName: 'tradeinitems-' + Date.now() + '.xlsx'
   })
}


type TradeInItemExportProps = {
   language: string
   currency: string
   ids: string[]
}

export const TradeInItemExport = ({language, currency, ids}: TradeInItemExportProps) => {
   const [open, setOpen] = useState<boolean>(true);
   const {data} = useExportTradeInItemsQuery({
      variables: {
         tradeIns: ids
      }
   });

   useEffect(() => {
      if (data?.TradeIns) {
         setOpen(true);
         (async function () {
            const exportLines: ExportLine[] = []
            const tradeIns = ((data.TradeIns || []) as TradeInExportFragment[])
            for (const tradeIn of tradeIns) {
               const items = ((tradeIn.items || []) as TradeInExportItemItemFragment[])
               let itemNr: number = 1
               for (const item of items) {
                  exportLines.push({
                     item,
                     tradeIn,
                     itemNr: itemNr++
                  })
               }
            }
            await ItemExportToExcel(language, currency, exportLines);
            setOpen(false);
         })();
      }
   }, [currency, data, ids, language])

   return <Dialog open={open}>
      <DialogContent>
         <CircularProgress size={100}/>
         Preparing data, please wait...
      </DialogContent>
   </Dialog>
}
